import React from 'react'
import './Dropdown.css'
import Carot from './carot.svg'
import { Link } from 'react-router-dom'

const linkStyle = {
  margin: "0rem 24px 0rem 24px",
  textDecoration: "none",
  color: 'white',
  fontSize: "12px",
};

export default function Dropdown() {
  return (
    <div>
      <div className='topics'>
      <Link to = "/html" style={linkStyle}><h1>HTML</h1></Link>
            <div class="dropdown">
              <button class="dropbtn">Lessons 
              <img src= {Carot} />
              </button>
              <div class="dropdown-content">
                  <h4>Module 1:Basics</h4>  
                  <Link to = "/htmlm1l1">1. What is HTML?</Link>
                  <Link to = "/htmlm1l2">2. Let's write some HTML code</Link>
                  <Link to = "/htmlm1l3">3. Elements and Tags</Link>
                  <Link to = "/htmlm1l4">4. Setting up development environment</Link>
                  <a href="#">5. Coding in local </a>
                  <a href="#">6. What this code </a>
                  <a href="#">7. Boilerplate code + Emmet</a>

                  <h4>Module 2:Elements & Tags</h4>  
                  <a href="#">1. Heading element</a>
                  <a href="#">2. Paragraph element</a>
                  <a href="#">3. Anchor tag + Introduction to attributes</a>
                  <a href="#">4. The Image element</a>
                  <a href="#">5. Nesting elements </a>
                  <a href="#">6. "div" tag </a>
                  <a href="#">7. List</a>
                  <a href="#">8. Table</a>
                  <a href="#">9. HTML Forms</a>
                  <a href="#">10. Empty elements</a>

                  <h4>Module 3: Sementic Elements</h4>  
                  <a href="#">1. Sementic Elements</a>
                  <a href="#">2. Header element</a>
                  <a href="#">3. Main element</a>
                  <a href="#">4. Article contents element</a>
                  <a href="#">5. Footer element</a>
                  <a href="#">6. The Document Title element</a>
                  <a href="#">7. The metadata element</a>
                  <a href="#">8. Favicon</a>
                  <a href="#">9. Alt attribute</a>
                  
              </div>
            </div> 
      </div>
    </div>
  )
}
